export const round = (value) => {
    const result = Math.round(value * 100) / 100;
    return result.toFixed(2);
};